import { readingModes } from '@/mocks/home';

export default function ReadingModeSection() {
  return (
    <section id="reading-modes" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">多种漫画阅读模式</h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            爱漫画网提供下拉式漫画阅读、翻页漫画、无弹窗漫画等多种阅读模式，支持漫画全屏观看，满足你不同的追漫习惯
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {readingModes.map((mode, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60 hover:border-primary-200 transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${mode.icon} text-xl text-primary-500 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-3">{mode.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{mode.desc}</p>
              <div className="flex flex-wrap gap-2">
                {mode.features.map((f, j) => (
                  <span key={j} className="text-xs bg-secondary-100 text-secondary-700 px-2 py-1 rounded-md whitespace-nowrap">
                    {f}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}